import * as React from "react";
const SVGComponent = (props) => (
    <svg
        width={22}
        height={22}
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <circle cx={12.4785} cy={12} r={12} fill="#4AD395" fillOpacity={0.1} />
        <path
            d="M6.94043 12.0848L11.583 16.426C11.6917 16.5276 11.8645 16.5124 11.9538 16.3934L18.0174 8.30859"
            stroke="#4AD395"
            strokeWidth={2}
            strokeLinecap="round"
        />
    </svg>
);
export default SVGComponent;
